import {
  QuoteFilterItem,
  ScheduleOptions,
  SportFilterItem,
  SportFiltersType,
  TimingFilterItem,
  sequence,
} from '../../types';
import { hasValue, isMatch } from 'utility/functions';

import { GamesUIComponentFilterEnum } from 'types/swagger';
import { useGetLabelsByKeys } from 'hooks/useLingUI';

const clean = (input: string): string => {
  return input
    .replace(/\^|\$|\(|\)|\[|\]|\*|\\s||\\d/gim, '')
    .replace(/\.| /gim, '_')
    .toLowerCase();
};

const keyList: Array<string> = [
  'prematch-filters-quote',
  'prematch-filters-schedule',
  'prematch-filters-quote-min',
  'prematch-filters-quote-max',
  'prematch-filters-quote-tooltip',
  'prematch-filters-schedule-tooltip',
  ...ScheduleOptions.map((value) => `prematch-filters-schedule-${clean(value)}`),
];

export interface PrematchFiltersHookType {
  filters: SportFiltersType;
  sequence: Array<string>;
}

export const usePrematchFilters = (): PrematchFiltersHookType => {
  const dictionary: Record<string, string> = {};
  useGetLabelsByKeys(keyList).forEach((x, index) => {
    dictionary[keyList[index]] = x;
  });

  const getLabel = (key: string, fallback?: string | number): string => {
    const wKey = clean(key);
    let result = dictionary[wKey];
    if (hasValue(fallback) && isMatch(result, `${wKey}$`)) {
      return `${fallback}`;
    }
    return result;
  };

  const scheduleOptions: Array<TimingFilterItem> = ScheduleOptions.map(
    (value) =>
      ({
        value,
        label: getLabel(`prematch-filters-schedule-${clean(value)}`),
      } as TimingFilterItem)
  );

  const filters: SportFiltersType = {
    quote: {
      type: 'range',
      name: getLabel('prematch-filters-quote'),
      description: getLabel('prematch-filters-quote-tooltip'),
      values: [
        {
          step: 0.01,
          range: [1, 100],
          labelMin: getLabel('prematch-filters-quote-min'),
          labelMax: getLabel('prematch-filters-quote-max'),
          direction: 'ltr',
          defaultValue: [1, 100],
        },
      ],
    } as SportFilterItem<QuoteFilterItem>,
    schedule: {
      type: GamesUIComponentFilterEnum.Chip,
      name: getLabel('prematch-filters-schedule'),
      values: scheduleOptions,
      description: getLabel('prematch-filters-schedule-tooltip'),
    },
  };

  return { filters, sequence };
};
